import React from 'react';
import { useParams } from 'react-router-dom';
import { useAuth } from '../../../context/AuthContext';
import PageTabs from '../../../components/PageTabs';
import {
  UserCheck,
  ArrowCounterClockwise as RotateCcw,
} from '@phosphor-icons/react';

const CustomersTab = ({ children, darkMode, ...props }) => {
  const { slug } = useParams();
  const { user } = useAuth();
  const isServicesType = ['SERVICES', 'SALON'].includes(user?.businessType);

  const tabs = [
    { key: 'all', label: 'Customers', icon: UserCheck, path: `/${slug}/owner/customers` },
    ...(!isServicesType ? [
      { key: 'returns', label: 'Returns', icon: RotateCcw, path: `/${slug}/owner/customers/returns` },
    ] : []),
  ];

  return (
    <>
      <PageTabs tabs={tabs} darkMode={darkMode} />
      {children}
    </>
  );
};

export default CustomersTab;
